import ServiceBase from "base/baseService"

export default class IbsCstService extends ServiceBase {

    title = "CST do IBS"
    pluralTitle = "CSTs do IBS"
    url = '/cadastro/fiscal/ibscst'
    frontUrl = '/cadastro/fiscal/ibscst'
    frontUrlList = '/cadastro/fiscal/ibscstlist'
    primaryKey = 'codigo_ibscst'
    ignoredsSchemaConvertions = []

    prepareToFront(data = {}) {

        // Strings notNullable
        data.codigo_ibscst = data?.codigo_ibscst || ''
        data.descricao_ibscst = data?.descricao_ibscst || ''

        return data
    }

    prepareToSave({ data }) {
        return data
    }

}
